import { includes } from 'lodash';
import { SECTION_CATEGORY, SECTION_HOMEPAGE, SECTION_MY_POSTS, SECTION_POST_LIST, SECTION_RELATED_POSTS, } from './sections';
export const LAYOUT_CARD_SMALL = 0;
export const LAYOUT_CARD_MEDIUM = 1;
export const LAYOUT_CARD_LARGE = 2;
export const LAYOUT_CARD_PROFILE = 3;
export const LAYOUT_FULL_POST = 4;
export const LAYOUT_MOBILE = 5;
export const LAYOUT_SIDE_BY_SIDE = 6;
export const LAYOUT_GRID = 7;
export const LAYOUT_TEXT_ON_IMAGE_SMALL = 8;
export const LAYOUT_TEXT_ON_IMAGE_MEDIUM = 9;
export const LAYOUT_ONE_COLUMN_MOBILE = 10;
export const LAYOUT_SIDE_BY_SIDE_MOBILE = 11;
export const LAYOUT_TEXT_ON_IMAGE_MOBILE = 12;
export const LAYOUT_PG_TEXT_ON_IMAGE_SMALL = 23;
export const LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM = 13;
export const LAYOUT_PG_TEXT_ON_IMAGE_LARGE = 24;
export const LAYOUT_PG_CARD_MEDIUM = 14;
export const LAYOUT_PG_SIDE_BY_SIDE = 15;
export const LAYOUT_PG_SIDE_BY_SIDE_RIGHT = 22;
export const LAYOUT_PG_GRID = 16;
export const LAYOUT_PG_GRID_INTERMEDIATE = 20;
export const LAYOUT_PG_GRID_LARGE = 21;
export const LAYOUT_PG_ONE_COLUMN = 17;
export const LAYOUT_SLIDER = 18;
export const LAYOUT_LIST = 19;
export const LAYOUT_LIST_MEDIUM = 25;
export const LAYOUT_LIST_LARGE = 26;
const OLD_LAYOUT_PG_MAP = {
    [LAYOUT_CARD_MEDIUM]: LAYOUT_PG_CARD_MEDIUM,
    [LAYOUT_SIDE_BY_SIDE]: LAYOUT_PG_SIDE_BY_SIDE,
    [LAYOUT_TEXT_ON_IMAGE_MEDIUM]: LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM,
    [LAYOUT_GRID]: LAYOUT_PG_GRID,
    [LAYOUT_CARD_SMALL]: LAYOUT_PG_CARD_MEDIUM,
    [LAYOUT_TEXT_ON_IMAGE_SMALL]: LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM,
    [LAYOUT_CARD_LARGE]: LAYOUT_PG_GRID, // one col
};
export const getPGMappedLayout = (layoutType) => {
    if (isLayoutOneColumn(layoutType)) {
        return LAYOUT_PG_ONE_COLUMN;
    }
    return OLD_LAYOUT_PG_MAP[layoutType] || layoutType;
};
export const LAYOUT_NAMES_BY_ID = {
    [LAYOUT_CARD_SMALL]: 'Brick',
    [LAYOUT_CARD_MEDIUM]: 'Tiled',
    [LAYOUT_CARD_LARGE]: 'One column',
    [LAYOUT_FULL_POST]: 'Full post',
    [LAYOUT_SIDE_BY_SIDE]: 'Side by side',
    [LAYOUT_GRID]: 'Editorial',
    [LAYOUT_TEXT_ON_IMAGE_SMALL]: 'Postcard',
    [LAYOUT_TEXT_ON_IMAGE_MEDIUM]: 'Magazine',
    [LAYOUT_ONE_COLUMN_MOBILE]: 'Mobile One Column',
    [LAYOUT_SIDE_BY_SIDE_MOBILE]: 'Mobile Side By Side',
    [LAYOUT_TEXT_ON_IMAGE_MOBILE]: 'Mobile Magazine',
    [LAYOUT_PG_TEXT_ON_IMAGE_SMALL]: 'Magazine Pro Gallery (small)',
    [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM]: 'Magazine Pro Gallery',
    [LAYOUT_PG_TEXT_ON_IMAGE_LARGE]: 'Magazine Pro Gallery (large)',
    [LAYOUT_PG_CARD_MEDIUM]: 'Tiled Pro Gallery',
    [LAYOUT_PG_SIDE_BY_SIDE]: 'Side by side Pro Gallery',
    [LAYOUT_PG_SIDE_BY_SIDE_RIGHT]: 'Side by side (right) Pro Gallery',
    [LAYOUT_PG_GRID]: 'Editorial Pro Gallery',
    [LAYOUT_PG_GRID_INTERMEDIATE]: 'Editorial Pro Gallery (medium)',
    [LAYOUT_PG_GRID_LARGE]: 'Editorial Pro Gallery (large)',
    [LAYOUT_PG_ONE_COLUMN]: 'One column Pro Gallery',
    [LAYOUT_SLIDER]: 'Slider',
    [LAYOUT_LIST]: 'List',
    [LAYOUT_LIST_MEDIUM]: 'List Medium',
    [LAYOUT_LIST_LARGE]: 'List Large',
};
export const getLayoutNameById = (layoutId) => LAYOUT_NAMES_BY_ID[layoutId];
export const PAGINATION_TYPE_ON_SCROLL_DOWN = 0;
export const PAGINATION_TYPE_WITH_PAGE_NUMBERS = 1;
export const PAGINATION_TYPE_NAME_BY_ID = {
    [PAGINATION_TYPE_ON_SCROLL_DOWN]: 'On scroll down',
    [PAGINATION_TYPE_WITH_PAGE_NUMBERS]: 'With page numbers',
};
export const getLayoutPaginationTypeNameById = (typeId) => PAGINATION_TYPE_NAME_BY_ID[typeId];
export const SEO_LAYOUT_TYPE_FALLBACK = LAYOUT_GRID;
export const LAYOUT_NAME_CARD_SMALL = 'small';
export const LAYOUT_NAME_CARD_MEDIUM = 'medium';
export const LAYOUT_NAME_CARD_LARGE = 'large';
export const LAYOUT_NAME_CARD_PROFILE = 'profile';
export const LAYOUT_NAME_FULL_POST = 'full';
export const LAYOUT_NAME_MOBILE = 'mobile';
export const LAYOUT_NAME_SIDE_BY_SIDE = 'side-by-side';
export const LAYOUT_NAME_GRID = 'grid';
export const LAYOUT_NAME_TEXT_ON_IMAGE_SMALL = 'text-on-image-small';
export const LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM = 'text-on-image-medium';
export const LAYOUT_NAME_ONE_COLUMN_MOBILE = 'one-column-mobile';
export const LAYOUT_NAME_SIDE_BY_SIDE_MOBILE = 'side-by-side-mobile';
export const LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE = 'text-on-image-mobile';
export const LAYOUT_NAME_PG_TEXT_ON_IMAGE_SMALL = 'pg-text-on-image-small';
export const LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM = 'pg-text-on-image-medium';
export const LAYOUT_NAME_PG_TEXT_ON_IMAGE_LARGE = 'pg-text-on-image-large';
export const LAYOUT_NAME_PG_CARD_MEDIUM = 'pg-medium';
export const LAYOUT_NAME_PG_SIDE_BY_SIDE = 'pg-side-by-side';
export const LAYOUT_NAME_PG_SIDE_BY_SIDE_RIGHT = 'pg-side-by-side-right';
export const LAYOUT_NAME_PG_GRID = 'pg-grid';
export const LAYOUT_NAME_PG_GRID_INTERMEDIATE = 'pg-grid-intermediate';
export const LAYOUT_NAME_PG_GRID_LARGE = 'pg-grid-large';
export const LAYOUT_NAME_PG_ONE_COLUMN = 'pg-one-column';
export const LAYOUT_NAME_SLIDER = 'slider';
export const LAYOUT_NAME_LIST = 'list';
export const LAYOUT_NAME_LIST_MEDIUM = 'list-medium';
export const LAYOUT_NAME_LIST_LARGE = 'list-large';
export const MOBILE_LAYOUT_NAMES = [
    LAYOUT_NAME_MOBILE,
    LAYOUT_NAME_ONE_COLUMN_MOBILE,
    LAYOUT_NAME_SIDE_BY_SIDE_MOBILE,
    LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE,
];
export const FEED_LAYOUT_TYPES = {
    [LAYOUT_CARD_SMALL]: LAYOUT_NAME_CARD_SMALL,
    [LAYOUT_CARD_MEDIUM]: LAYOUT_NAME_CARD_MEDIUM,
    [LAYOUT_CARD_LARGE]: LAYOUT_NAME_CARD_LARGE,
    [LAYOUT_FULL_POST]: LAYOUT_NAME_FULL_POST,
    [LAYOUT_SIDE_BY_SIDE]: LAYOUT_NAME_SIDE_BY_SIDE,
    [LAYOUT_GRID]: LAYOUT_NAME_GRID,
    [LAYOUT_TEXT_ON_IMAGE_SMALL]: LAYOUT_NAME_TEXT_ON_IMAGE_SMALL,
    [LAYOUT_TEXT_ON_IMAGE_MEDIUM]: LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM,
    [LAYOUT_TEXT_ON_IMAGE_MOBILE]: LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE,
    [LAYOUT_PG_TEXT_ON_IMAGE_SMALL]: LAYOUT_NAME_PG_TEXT_ON_IMAGE_SMALL,
    [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM]: LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM,
    [LAYOUT_PG_TEXT_ON_IMAGE_LARGE]: LAYOUT_NAME_PG_TEXT_ON_IMAGE_LARGE,
    [LAYOUT_PG_CARD_MEDIUM]: LAYOUT_NAME_PG_CARD_MEDIUM,
    [LAYOUT_PG_SIDE_BY_SIDE]: LAYOUT_NAME_PG_SIDE_BY_SIDE,
    [LAYOUT_PG_SIDE_BY_SIDE_RIGHT]: LAYOUT_NAME_PG_SIDE_BY_SIDE_RIGHT,
    [LAYOUT_PG_GRID]: LAYOUT_NAME_PG_GRID,
    [LAYOUT_PG_GRID_INTERMEDIATE]: LAYOUT_NAME_PG_GRID_INTERMEDIATE,
    [LAYOUT_PG_GRID_LARGE]: LAYOUT_NAME_PG_GRID_LARGE,
    [LAYOUT_PG_ONE_COLUMN]: LAYOUT_NAME_PG_ONE_COLUMN,
    [LAYOUT_LIST]: LAYOUT_NAME_LIST,
    [LAYOUT_LIST_MEDIUM]: LAYOUT_NAME_LIST_MEDIUM,
    [LAYOUT_LIST_LARGE]: LAYOUT_NAME_LIST_LARGE,
    [LAYOUT_SLIDER]: LAYOUT_NAME_SLIDER,
};
export const POST_LIST_LAYOUT_TYPES = {
    [LAYOUT_PG_GRID]: LAYOUT_NAME_PG_GRID,
    [LAYOUT_PG_GRID_LARGE]: LAYOUT_NAME_PG_GRID_LARGE,
    [LAYOUT_SLIDER]: LAYOUT_NAME_SLIDER,
    [LAYOUT_LIST_MEDIUM]: LAYOUT_NAME_LIST_MEDIUM,
    [LAYOUT_LIST_LARGE]: LAYOUT_NAME_LIST_LARGE,
    [LAYOUT_PG_SIDE_BY_SIDE]: LAYOUT_NAME_PG_SIDE_BY_SIDE,
    [LAYOUT_PG_SIDE_BY_SIDE_RIGHT]: LAYOUT_NAME_PG_SIDE_BY_SIDE_RIGHT,
    [LAYOUT_PG_ONE_COLUMN]: LAYOUT_NAME_PG_ONE_COLUMN,
    [LAYOUT_PG_TEXT_ON_IMAGE_SMALL]: LAYOUT_NAME_PG_TEXT_ON_IMAGE_SMALL,
    [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM]: LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM,
    [LAYOUT_PG_TEXT_ON_IMAGE_LARGE]: LAYOUT_NAME_PG_TEXT_ON_IMAGE_LARGE,
    [LAYOUT_PG_GRID_INTERMEDIATE]: LAYOUT_NAME_PG_GRID_INTERMEDIATE,
    [LAYOUT_LIST]: LAYOUT_NAME_LIST,
    [LAYOUT_PG_CARD_MEDIUM]: LAYOUT_NAME_PG_CARD_MEDIUM,
};
export const RELATED_POSTS_LAYOUT_TYPES = {
    [LAYOUT_PG_GRID]: LAYOUT_NAME_PG_GRID,
    [LAYOUT_PG_GRID_LARGE]: LAYOUT_NAME_PG_GRID_LARGE,
    [LAYOUT_SLIDER]: LAYOUT_NAME_SLIDER,
    [LAYOUT_LIST_MEDIUM]: LAYOUT_NAME_LIST_MEDIUM,
    [LAYOUT_LIST_LARGE]: LAYOUT_NAME_LIST_LARGE,
    [LAYOUT_PG_SIDE_BY_SIDE]: LAYOUT_NAME_PG_SIDE_BY_SIDE,
    [LAYOUT_PG_SIDE_BY_SIDE_RIGHT]: LAYOUT_NAME_PG_SIDE_BY_SIDE_RIGHT,
    [LAYOUT_PG_ONE_COLUMN]: LAYOUT_NAME_PG_ONE_COLUMN,
    [LAYOUT_PG_TEXT_ON_IMAGE_SMALL]: LAYOUT_NAME_PG_TEXT_ON_IMAGE_SMALL,
    [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM]: LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM,
    [LAYOUT_PG_TEXT_ON_IMAGE_LARGE]: LAYOUT_NAME_PG_TEXT_ON_IMAGE_LARGE,
    [LAYOUT_PG_GRID_INTERMEDIATE]: LAYOUT_NAME_PG_GRID_INTERMEDIATE,
    [LAYOUT_LIST]: LAYOUT_NAME_LIST,
    [LAYOUT_PG_CARD_MEDIUM]: LAYOUT_NAME_PG_CARD_MEDIUM,
};
export const DESKTOP_LAYOUT_TYPES_TO_MOBILE = {
    [LAYOUT_PG_GRID]: LAYOUT_PG_GRID,
    [LAYOUT_PG_GRID_INTERMEDIATE]: LAYOUT_PG_GRID,
    [LAYOUT_PG_GRID_LARGE]: LAYOUT_PG_GRID,
    [LAYOUT_SLIDER]: LAYOUT_SLIDER,
    [LAYOUT_LIST]: LAYOUT_LIST,
    [LAYOUT_LIST_MEDIUM]: LAYOUT_LIST,
    [LAYOUT_LIST_LARGE]: LAYOUT_LIST,
    [LAYOUT_PG_SIDE_BY_SIDE]: LAYOUT_PG_GRID,
    [LAYOUT_PG_SIDE_BY_SIDE_RIGHT]: LAYOUT_PG_GRID,
    [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM]: LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM,
    [LAYOUT_PG_TEXT_ON_IMAGE_SMALL]: LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM,
    [LAYOUT_PG_TEXT_ON_IMAGE_LARGE]: LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM,
    [LAYOUT_PG_ONE_COLUMN]: LAYOUT_PG_GRID,
    [LAYOUT_PG_CARD_MEDIUM]: LAYOUT_PG_GRID,
};
export const MY_POSTS_LAYOUT_TYPES = {
    [LAYOUT_PG_SIDE_BY_SIDE]: LAYOUT_NAME_PG_SIDE_BY_SIDE,
};
export const LAYOUT_TYPES = Object.assign(Object.assign(Object.assign(Object.assign({}, FEED_LAYOUT_TYPES), POST_LIST_LAYOUT_TYPES), RELATED_POSTS_LAYOUT_TYPES), MY_POSTS_LAYOUT_TYPES);
export const LAYOUT_TYPES_BY_SECTION = {
    [SECTION_HOMEPAGE]: FEED_LAYOUT_TYPES,
    [SECTION_CATEGORY]: FEED_LAYOUT_TYPES,
    [SECTION_POST_LIST]: POST_LIST_LAYOUT_TYPES,
    [SECTION_RELATED_POSTS]: RELATED_POSTS_LAYOUT_TYPES,
    [SECTION_MY_POSTS]: MY_POSTS_LAYOUT_TYPES,
};
export const getLayoutTypeById = (layoutId) => LAYOUT_TYPES[layoutId];
export const LAYOUT_TYPES_MOBILE = {
    [LAYOUT_ONE_COLUMN_MOBILE]: LAYOUT_NAME_ONE_COLUMN_MOBILE,
    [LAYOUT_SIDE_BY_SIDE_MOBILE]: LAYOUT_NAME_SIDE_BY_SIDE_MOBILE,
    [LAYOUT_TEXT_ON_IMAGE_MOBILE]: LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE,
};
export const OTHER_LAYOUT_TYPES = {
    [LAYOUT_CARD_PROFILE]: LAYOUT_NAME_CARD_PROFILE,
    [LAYOUT_MOBILE]: LAYOUT_NAME_MOBILE,
};
export const getLayoutName = (layoutType) => LAYOUT_TYPES[layoutType] ||
    LAYOUT_TYPES_MOBILE[layoutType] ||
    OTHER_LAYOUT_TYPES[layoutType];
export const isLayoutProGallery = (layoutType) => [
    LAYOUT_PG_TEXT_ON_IMAGE_SMALL,
    LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM,
    LAYOUT_PG_TEXT_ON_IMAGE_LARGE,
    LAYOUT_PG_CARD_MEDIUM,
    LAYOUT_PG_SIDE_BY_SIDE,
    LAYOUT_PG_SIDE_BY_SIDE_RIGHT,
    LAYOUT_PG_GRID,
    LAYOUT_PG_GRID_INTERMEDIATE,
    LAYOUT_PG_GRID_LARGE,
    LAYOUT_PG_ONE_COLUMN,
    LAYOUT_LIST,
    LAYOUT_LIST_MEDIUM,
    LAYOUT_LIST_LARGE,
    LAYOUT_SLIDER,
].includes(Number(layoutType));
export const isPGLayoutWithDescription = (layoutType) => [
    LAYOUT_PG_CARD_MEDIUM,
    LAYOUT_PG_SIDE_BY_SIDE,
    LAYOUT_PG_SIDE_BY_SIDE_RIGHT,
    LAYOUT_PG_GRID,
    LAYOUT_PG_GRID_INTERMEDIATE,
    LAYOUT_PG_GRID_LARGE,
    LAYOUT_PG_ONE_COLUMN,
    LAYOUT_SLIDER,
].includes(Number(layoutType));
export const isLayoutNameOneOfProGallery = (layoutName) => [
    LAYOUT_NAME_PG_TEXT_ON_IMAGE_SMALL,
    LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM,
    LAYOUT_NAME_PG_TEXT_ON_IMAGE_LARGE,
    LAYOUT_NAME_PG_CARD_MEDIUM,
    LAYOUT_NAME_PG_SIDE_BY_SIDE,
    LAYOUT_NAME_PG_SIDE_BY_SIDE_RIGHT,
    LAYOUT_NAME_PG_GRID,
    LAYOUT_NAME_PG_ONE_COLUMN,
].includes(layoutName);
export const PG_LAYOUTS_WITH_CONTENT_HEIGHT = [
    LAYOUT_PG_GRID,
    LAYOUT_PG_GRID_INTERMEDIATE,
    LAYOUT_PG_GRID_LARGE,
    LAYOUT_PG_CARD_MEDIUM,
    LAYOUT_PG_ONE_COLUMN,
    LAYOUT_SLIDER,
    LAYOUT_LIST,
    LAYOUT_LIST_MEDIUM,
    LAYOUT_LIST_LARGE,
];
const isLayoutOneColumn = (layoutType) => Number(layoutType) === LAYOUT_CARD_LARGE;
export const isLayoutPGOneColumn = (layoutType) => Number(layoutType) === LAYOUT_PG_ONE_COLUMN;
export const isLayoutPGGrid = (layoutType) => Number(layoutType) === LAYOUT_PG_GRID ||
    Number(layoutType) === LAYOUT_PG_GRID_INTERMEDIATE ||
    Number(layoutType) === LAYOUT_PG_GRID_LARGE;
export const isLayoutPGSideBySide = (layoutType) => Number(layoutType) === LAYOUT_PG_SIDE_BY_SIDE ||
    Number(layoutType) === LAYOUT_PG_SIDE_BY_SIDE_RIGHT;
export const isLayoutPGCardMedium = (layoutType) => Number(layoutType) === LAYOUT_PG_CARD_MEDIUM;
export const isLayoutPGCard = (layoutType) => Number(layoutType) === LAYOUT_PG_CARD_MEDIUM;
export const isLayoutPGWithContentHeight = (layoutType) => includes(PG_LAYOUTS_WITH_CONTENT_HEIGHT, Number(layoutType));
export const isLayoutGrid = (layoutType) => Number(layoutType) === LAYOUT_GRID;
export const isLayoutFullPost = (layoutType) => Number(layoutType) === LAYOUT_FULL_POST;
export const isLayoutTextOnImage = (layoutType) => includes([
    LAYOUT_TEXT_ON_IMAGE_SMALL,
    LAYOUT_TEXT_ON_IMAGE_MEDIUM,
    LAYOUT_TEXT_ON_IMAGE_MOBILE,
    LAYOUT_PG_TEXT_ON_IMAGE_SMALL,
    LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM,
    LAYOUT_PG_TEXT_ON_IMAGE_LARGE,
], Number(layoutType));
export const isLayoutSlider = (layoutType) => Number(layoutType) === LAYOUT_SLIDER;
export const isLayoutList = (layoutType) => Number(layoutType) === LAYOUT_LIST ||
    Number(layoutType) === LAYOUT_LIST_MEDIUM ||
    Number(layoutType) === LAYOUT_LIST_LARGE;
export const isLayoutMobile = (layoutType) => includes([
    LAYOUT_MOBILE,
    LAYOUT_ONE_COLUMN_MOBILE,
    LAYOUT_SIDE_BY_SIDE_MOBILE,
    LAYOUT_TEXT_ON_IMAGE_MOBILE,
], Number(layoutType));
export const isLayoutNameMobile = (layoutName) => includes(MOBILE_LAYOUT_NAMES, layoutName);
export const isLayoutNamePGSideBySide = (layoutName) => includes([LAYOUT_NAME_PG_SIDE_BY_SIDE, LAYOUT_NAME_PG_SIDE_BY_SIDE_RIGHT], layoutName);
export const isLayoutNamePGOneColumn = (layoutName) => layoutName === LAYOUT_NAME_PG_ONE_COLUMN;
export const isLayoutNameGrid = (layoutName) => layoutName === LAYOUT_NAME_GRID;
export const isLayoutNameSlider = (layoutName) => layoutName === LAYOUT_NAME_SLIDER;
export const isLayoutNameList = (layoutName) => includes([LAYOUT_NAME_LIST, LAYOUT_NAME_LIST_MEDIUM, LAYOUT_NAME_LIST_LARGE], layoutName);
export const isLayoutNameTextOnImage = (layoutName) => includes([
    LAYOUT_NAME_TEXT_ON_IMAGE_SMALL,
    LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM,
    LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE,
    LAYOUT_NAME_PG_TEXT_ON_IMAGE_SMALL,
    LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM,
    LAYOUT_NAME_PG_TEXT_ON_IMAGE_LARGE,
], layoutName);
const SUPPORTS_MULTIPLE_PAGES_PAGINATION = [
    LAYOUT_CARD_LARGE,
    LAYOUT_FULL_POST,
    LAYOUT_GRID,
    LAYOUT_PG_GRID_INTERMEDIATE,
    LAYOUT_PG_GRID_LARGE,
    LAYOUT_MOBILE,
    LAYOUT_SIDE_BY_SIDE,
    LAYOUT_TEXT_ON_IMAGE_MEDIUM,
    LAYOUT_TEXT_ON_IMAGE_SMALL,
    LAYOUT_ONE_COLUMN_MOBILE,
    LAYOUT_SIDE_BY_SIDE_MOBILE,
    LAYOUT_TEXT_ON_IMAGE_MOBILE,
    LAYOUT_PG_TEXT_ON_IMAGE_SMALL,
    LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM,
    LAYOUT_PG_TEXT_ON_IMAGE_LARGE,
    LAYOUT_PG_SIDE_BY_SIDE,
    LAYOUT_PG_SIDE_BY_SIDE_RIGHT,
    LAYOUT_PG_GRID,
    LAYOUT_PG_ONE_COLUMN,
    LAYOUT_LIST,
    LAYOUT_LIST_MEDIUM,
    LAYOUT_LIST_LARGE,
];
export const isMultiplePagesSupported = (layoutType) => includes(SUPPORTS_MULTIPLE_PAGES_PAGINATION, layoutType);
export const isAuthorImageSupported = (layoutId) => {
    if ([
        LAYOUT_TEXT_ON_IMAGE_SMALL,
        LAYOUT_TEXT_ON_IMAGE_MEDIUM,
        LAYOUT_PG_TEXT_ON_IMAGE_SMALL,
        LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM,
        LAYOUT_PG_TEXT_ON_IMAGE_LARGE,
    ].includes(layoutId)) {
        return false;
    }
    return true;
};
export const SIDE_BY_SIDE_LAYOUT_IMAGE_LEFT = 0;
export const SIDE_BY_SIDE_LAYOUT_IMAGE_RIGHT = 1;
export const SIDE_BY_SIDE_LAYOUT_IMAGE_NONE = 2;
//# sourceMappingURL=layout-types.js.map